<template>
  <v-sheet color="grey800" class="px-4 py-3 grey200--text">
    <v-form v-model="valid" @submit.prevent="onSave">
      <v-row>
        <v-col cols="12" class="p-0">
          <label
            for="fieldEmail"
            class="grey100--text d-block font-weight-bold" v-text="'Email address'"
          />
          <p class="body-2 lh-1-2 mb-3">
            Receive free promo codes, important account updates and other rewards. We don't spam!
          </p>

          <v-text-field
            id="fieldEmail" v-model="input" :rules="rules"
            placeholder="roleplayer@yahoo.com"
            class="settings-btn rounded-0"
            dense solo flat type="email"
            background-color="grey600"
          >
            <template #append-outer>
              <div v-if="verificationPending" class="primary800  d-flex align-center px-4 mr-2">
                <span class="primary500--text text-caption font-weight-semibold text-uppercase">Unverified</span>
              </div>

              <v-btn
                class="px-6 font-weight-semibold text-caption"
                :color="verificationPending ? 'blue800 blue400--text' : 'green800 green500--text'"
                height="38" tile
                :ripple="false" depressed
                :loading="loading"
                type="submit"
              >
                <span v-if="verified && input === value" class="green500--text text-caption font-weight-semibold text-uppercase text-no-wrap">
                  <fai :icon="['fas', 'check']" class="mr-1" /> Verified
                </span>
                <span v-else v-text="buttonText" />
              </v-btn>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </v-form>
  </v-sheet>
</template>

<script>
import { EMAIL_RE } from '@/utils/constants/regexes'

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    verified: Boolean,
    loading: Boolean,
  },
  data() {
    return {
      valid: false,
      input: this.value,
      rules: [
        v => (v?.length === 0 || EMAIL_RE.test(v)) || 'Invalid email',
      ],
    }
  },
  computed: {
    verificationPending() {
      return this.input && this.input === this.value && !this.verified
    },
    buttonText() {
      if (this.verificationPending) {
        return 'Resend'
      }

      return 'Update'
    },
  },
  methods: {
    onSave() {
      // user is removing email
      if (!this.input) {
        this.$emit('update', '')
        return
      }

      if (!this.valid) return
      if (this.verified && this.input === this.value) return

      this.$emit('update', this.input)
    },
  },
}
</script>

<style lang="scss" scoped>
  ::v-deep .settings-btn {
    .v-input__append-outer {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }
  }
</style>
